import { FormIdUtil } from '@onshape/www-inertia';
import ExternalUtil from '../ExternalUtil';
import RichMap from './RichMap';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class VwoUtil {
  private static readonly liveVwoGoalToFormIdMap = new RichMap<string, number>({
    default: 206, // a general conversion on live
    [FormIdUtil.names.unifiedSignup]: 222, // a conversion to form ID 182 on live
  });

  private static readonly stageVwoGoalToFormIdMap = new RichMap<string, number>({
    default: 207, // a general conversion on stage
    [FormIdUtil.names.unifiedSignup]: 221, // a conversion to form ID 182 on stage
  });

  private static readonly devVwoGoalToFormIdMap = new RichMap<string, number>({
    default: 208, // a general conversion on dev
    [FormIdUtil.names.unifiedSignup]: 220, // a conversion to form ID 182 on dev
  });

  /** send VWO custom conversion for split tests */
  public static vwoSubmitFormConversionPush({ formId }: { formId?: string }) {
    window._vis_opt_queue = window._vis_opt_queue || [];

    let options = this.devVwoGoalToFormIdMap;
    if (ExternalUtil.isStage()) options = this.stageVwoGoalToFormIdMap;
    if (ExternalUtil.isProduction()) options = this.liveVwoGoalToFormIdMap;

    let conversionId = 0;
    if (!formId) {
      conversionId = options.getOrDefaultKey('default', 'default');
    } else {
      conversionId = options.getOrDefaultKey(formId, 'default');
    }

    console.log('pushing VWO submit conversion: ', conversionId);

    window._vis_opt_queue.push(() => {
      if (!window._vis_opt_goal_conversion) return;
      window._vis_opt_goal_conversion(conversionId);
    });
  }
}
